module.exports = __webpack_public_path__ + "static/media/facebookLogo.6ffaac61.svg";